import React, { useState } from "react";
import ToolTipComponent from "../ToolTipComponent";
import useMobile from "../../../hooks/useMobile";
import { useSelection } from "../../../contexts/SelectionContext";

export default function InputSelectGroup({
  name,
  id,
  required,
  titleRus,
  message,
  restrictions,
  measureId,
  measureOptions,
  value,
  currentMeasure,
  onChange,
  onBlur,
  onBlock,
  ...props
}) {
  const { inputErrors, floatingRules } = useSelection();

  const isMobile = useMobile();

  let fieldError;
  if (inputErrors) {
    if (inputErrors.emptyRule?.length > 0)
      fieldError = inputErrors.emptyRule.find((item) => item.inputId === id);
    if (inputErrors.valueRule && !fieldError)
      fieldError = inputErrors.valueRule;
  }

  const floatedValue =
    floatingRules && id in floatingRules && floatingRules[id] > 0;

  const checkRestrictions = (value) => {
    if (value === "") {
      onChange(null);
      return;
    }

    const numValue = Number(value);

    if (isNaN(numValue)) onChange(null);
    else {
      let correctedValue = numValue;
      if (numValue < restrictions.min) correctedValue = restrictions.min;
      if (numValue > restrictions.max) correctedValue = restrictions.max;
      onChange(Number(correctedValue));
    }
    return;
  };

  const handleChange = (e) => {
    if (onBlock) return;

    let newValue = e.target.value;

    const filteredValue = newValue
      .replace(/,/g, ".")
      .replace(/[^0-9.]/g, "")
      .replace(/^0+(?=\d)/, "")
      .replace(/^(\d*\.\d*)\./g, "$1");

    if (newValue !== filteredValue) {
      e.target.value = filteredValue;
    }

    if (!floatedValue) {
      // Только если в поле не может быть дробных чисел
      if (restrictions) checkRestrictions(newValue);
    } else onChange(newValue === "" ? null : filteredValue);
  };

  const handleOnBlur = (e) => {
    if (onBlock) return;

    let newValue = e.target.value;

    onBlur(name, newValue);

    // Только если в поле могут быть дробные числа
    if (floatedValue && restrictions) checkRestrictions(newValue);
  };

  const handleMeasureChange = (e) => {
    if (onBlock) return;
    const newMeasure = e.target.value;
    onChange(value, newMeasure);
  };

  return (
    <div
      id={id}
      className={`form-group form-group-with-select ${
        isMobile ? "form-group-vertical" : ""
      }`}
    >
      <div className="label-group">
        <label
          htmlFor={id}
          className={`text-s ${required ? `required_${required}` : ""}`}
        >
          {titleRus}
        </label>
        {message && (
          <ToolTipComponent text={message} restrictions={restrictions}>
            <div className="icon icon-center help-icon"></div>
          </ToolTipComponent>
        )}
      </div>

      {Object.keys(measureOptions)?.length > 0 && (
        <select
          id={measureId}
          name={measureId}
          value={currentMeasure || ""}
          onChange={handleMeasureChange}
          className={`text-m ${onBlock ? "input-blocked" : ""}`}
        >
          {Object.entries(measureOptions).map(([optionName, optionValue]) => (
            <option value={optionValue} key={optionValue}>
              {optionName}
            </option>
          ))}
        </select>
      )}

      <input
        type="text"
        autoComplete="off"
        id={id}
        name={name}
        value={value !== null && value !== undefined ? value : ""}
        onChange={handleChange}
        onBlur={handleOnBlur}
        required={required === "required"}
        {...props}
        className={`text-m
          ${fieldError?.inputId === id ? "input-error" : ""} 
          ${onBlock ? "input-blocked" : ""}
        `}
      />
    </div>
  );
}
